module.exports = __webpack_public_path__ + "img/delete-icon-full.39a36a8b.svg";